/**
 * Chatwoot Profile Service
 *
 * Handles user profile endpoints that don't require account_id
 *
 * @see ProfileApi.md
 */

import { BaseChatwootService } from "../core/base-chatwoot-service";
import { ChatwootUser } from "../types/profile.types";

// TEMPORARY: Disable /api/accounts/profile hit during testing flows.
// Set back to false (or remove this block) when re-enabling profile API.
const TEMP_DISABLE_CHATWOOT_PROFILE_API = false;

export class ChatwootProfileService extends BaseChatwootService {
  constructor(baseUrl?: string) {
    super(baseUrl);
  }

  /**
   * Get User Profile
   * GET /api/accounts/profile
   *
   * Retrieves the current user's profile information from Chatwoot.
   * Returns complete user details including accounts, role, and custom attributes.
   *
   * @returns Promise<ChatwootUser> - User profile data
   *
   * @example
   * ```typescript
   * const profileService = new ChatwootProfileService();
   * const user = await profileService.getProfile();
   * console.log(user.name, user.email, user.accounts);
   * ```
   */
  async getProfile(): Promise<ChatwootUser> {
    if (TEMP_DISABLE_CHATWOOT_PROFILE_API) {
      return {
        id: 0,
        name: "Temporary Profile",
        email: "",
        accounts: [],
      };
    }

    return await this.get<ChatwootUser>("/api/accounts/profile");
  }
}
